import ChevronIcon from '@repo/ui/src/components/Icons/ChevronIcon';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  label: string;
  toggle: StateSetterFunction<boolean>;
  isOpen: boolean;
  hideOnDesktop?: boolean;
  className?: string;
  account?: boolean;
}

const MobileNavigationToggle = ({
  label,
  toggle,
  isOpen,
  hideOnDesktop = false,
  className,
  account,
}: Props) => {
  return (
    <div className={className}>
      <div className={classNames(account ? 'md:hidden' : 'sm:hidden')}>
        <label className="group peer-focus-visible:border-black grid grid-flow-col justify-between items-center">
          <h4
            data-testid="mobile-nav-header"
            className={classNames(account ? 'tra-text-web-body-xl' : 'tra-text-web-sub-2')}
          >
            {label}
          </h4>
          <input
            className="peer absolute h-0 w-0 cursor-pointer"
            aria-label={`${isOpen ? 'Close' : 'Open'} Navigation Menu`}
            type="checkbox"
            checked={isOpen}
            onChange={() => toggle(!isOpen)}
          />
          <span className="w-6 h-6 flex items-center outline-offset-2 outline-brand-300 outline-2 peer-focus-visible:outline">
            <ChevronIcon
              direction={isOpen ? 'up' : 'down'}
              className={classNames(isOpen ? 'text-brand-300' : 'text-neutral-300')}
            />
          </span>
        </label>
      </div>

      {!hideOnDesktop && (
        <h4 className="hidden tra-text-web-sub-2 mb-2 justify-between items-center sm:block">
          {label}
        </h4>
      )}
    </div>
  );
};

export default MobileNavigationToggle;
